// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PegOverrideResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * The peg override just created — POST /ai/credits/peg-overrides.
 *
 * Echoes the stored peg back as the decimal STRING it was persisted as, so the
 * console displays the value the column holds rather than the one the browser
 * happened to send.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PegOverrideResponseDados {
id: number
franquia_id: number
peg_usd: string
valid_from: string
}

export type AiCredits_PegOverrideResponse = ApiResponse<AiCredits_PegOverrideResponseDados>;

registerResponseContract('AiCredits_PegOverrideResponse', {
  id:          { type: 'number',  required: true },
  franquia_id: { type: 'number',  required: true },
  peg_usd:     { type: 'string',  required: true },
  valid_from:  { type: 'string',  required: true },
})
